import React, { useState } from 'react';
import { Card, CardContent, Checkbox, Stack } from '@mui/material';

import {
  REPEAT_OPTION_MONTHLY,
  CAL_REGISTER_FIELD_GROUP_TOGGLE,
  // CAL_REGISTER_FIELD_WEEK,
  CAL_REGISTER_FIELD_REPEAT,
  CAL_REGISTER_FIELD_TIMES,
  CAL_REGISTER_FIELD_TITLE,
  CAL_REGISTER_FIELD_DATE,
  CAL_REGISTER_FIELD_TIME,
  CAL_REGISTER_FIELD_CMD_TOGGLE,
  CAL_REGISTER_FIELD_MONTHLY_DATEPICKER,
  CAL_REGISTER_FIELD_YEARLY_DATEPICKER,
  REPEAT_OPTIONS,
  CAL_REGISTER_FIELD_WEEK,
  REGISTER_TOGGLE_GROUP_SELECT,
} from '../../common/consts';
import CalendarTitleTextField from './CalendarTitleTextField';
import CalendarExecDateField from './CalendarExecDateField';
import CalendarTimesToggleGroup from './CalendarTimesToggleGroup';
import CalendarRepeatField from './CalendarRepeatField';
import CalendarTargetToggleGroup from './CalendarTargetToggleGroup';
import CalendarCmdSwitch from './CalendarCmdSwitch';
import CalendarGroupSearchModal from './CalendarGroupSearchModal';

const CalendarUpdateItem = (props) => {
  const {
    bManageMode,
    readOnly,
    checked,
    command,
    execTime,
    title,
    repeatValue,
    groupLists,
    group,
    // defaultDate,
    index,
    cmds,
    handleInputChange,
    handleCheckChange,
  } = props;
  const [open, setOpen] = useState(false);

  const handleGroupChange = (value) => () => {
    const { list: groupList } = group;
    const list = groupList.filter(({ gId }) => gId === value);
    handleInputChange({
      target: { name: `${REGISTER_TOGGLE_GROUP_SELECT}-${index}`, value: list },
    });

    if (group.type === REGISTER_TOGGLE_GROUP_SELECT) {
      setOpen(true);
    }
  };

  const handleGroupUpdate = (list) => {
    handleInputChange({
      target: {
        name: `${REGISTER_TOGGLE_GROUP_SELECT}-${index}`,
        value: list,
      },
    });
    setOpen(false);
  };

  const handleGroupClose = () => setOpen(false);

  return (
    <>
      <Card>
        <CardContent>
          <Checkbox
            checked={checked}
            onChange={handleCheckChange}
            color="secondary"
          />
          <Stack sx={{ px: 1 }} rowGap={1.5}>
            <CalendarTitleTextField
              {...{
                name: `${CAL_REGISTER_FIELD_TITLE}-${index}`,
                value: title,
                onChange: handleInputChange,
                disabled: readOnly,
              }}
            />
            <CalendarExecDateField
              {...{
                name: `${CAL_REGISTER_FIELD_DATE}-${index}`,
                value: execTime && execTime.format('YYYY-MM-DD'),
                onChange: handleInputChange,
                disabled: readOnly,
              }}
            />
            <CalendarTimesToggleGroup
              {...{
                name: `${CAL_REGISTER_FIELD_TIMES}-${index}`,
                value: repeatValue.value.times,
                onChange: (e, v) =>
                  handleInputChange({
                    target: {
                      name: `${CAL_REGISTER_FIELD_TIMES}-${index}`,
                      value: v,
                    },
                  }),
                length: 5,
                disabled: readOnly,
              }}
            />
            <CalendarRepeatField
              {...{
                type: {
                  name: `${CAL_REGISTER_FIELD_REPEAT}-${index}`,
                  value: repeatValue.type,
                  // onChange: handleRepeatTypeChange,
                  onChange: (e, v) =>
                    handleInputChange({
                      target: {
                        name: `${CAL_REGISTER_FIELD_REPEAT}-${index}`,
                        value: v,
                      },
                    }),
                  list: REPEAT_OPTIONS,
                },
                weekday: {
                  name: `${CAL_REGISTER_FIELD_WEEK}-${index}`,
                  value: repeatValue.value.day,
                  onChange: (e, v) =>
                    handleInputChange({
                      target: {
                        name: `${CAL_REGISTER_FIELD_WEEK}-${index}`,
                        value: v,
                      },
                    }),
                  // onChange: handleWeekChange,
                },
                month: {
                  name: `month-${index}`,
                  value: repeatValue.value.month,
                  onChange: handleInputChange,
                  // onChange: handleSelectChange,
                },
                date: {
                  name:
                    repeatValue.type === REPEAT_OPTION_MONTHLY
                      ? `${CAL_REGISTER_FIELD_MONTHLY_DATEPICKER}-${index}`
                      : `${CAL_REGISTER_FIELD_YEARLY_DATEPICKER}-${index}`,
                  value: repeatValue.value.date,
                  onChange: (e) =>
                    handleInputChange({
                      target: {
                        name:
                          repeatValue.type === REPEAT_OPTION_MONTHLY
                            ? `${CAL_REGISTER_FIELD_MONTHLY_DATEPICKER}-${index}`
                            : `${CAL_REGISTER_FIELD_YEARLY_DATEPICKER}-${index}`,
                        value: e.target.value,
                      },
                    }),
                  // onChange: handleSelectChange,
                },
                time: {
                  name: `${CAL_REGISTER_FIELD_TIME}-${index}`,
                  value: execTime && execTime.format('HH:mm'),
                  onChange: handleInputChange,
                },
                disabled: readOnly,
              }}
            />
            <CalendarCmdSwitch
              {...{
                name: `${CAL_REGISTER_FIELD_CMD_TOGGLE}-${index}`,
                command,
                cmds,
                onChange: (e) =>
                  handleInputChange({
                    target: {
                      name: `${e.target.name}-${index}`,
                      value: e.target.value,
                    },
                  }),
                disabled: readOnly,
              }}
            />
            {!bManageMode && (
              <CalendarTargetToggleGroup
                {...{
                  name: `${CAL_REGISTER_FIELD_GROUP_TOGGLE}-${index}`,
                  value: group.type,
                  list: group.list,
                  onChange: handleGroupChange,
                  onItemChange: handleGroupChange,
                  disabled: readOnly,
                  fullWidth: true,
                }}
              />
            )}
          </Stack>
        </CardContent>
      </Card>
      {open && (
        <CalendarGroupSearchModal
          {...{
            open,
            items: { groupLists },
            onUpdate: handleGroupUpdate,
            onCancel: handleGroupClose,
            hideBackdrop: true,
          }}
        />
      )}
    </>
  );
};

export default CalendarUpdateItem;
